import React from 'react'
import { Flex } from 'antd'
import { Color } from '../../../Common/Color'
import News from './News'
import Goal from './Goal'
import Solution from './Solution'
import MedicalDevices from './MedicalDevices'
import Consultation from './Consultation'

export default function MobileHomePage ({ news }) {
  return (
    <Flex vertical gap='1em' style={{ backgroundColor: Color.white }}>
      <News news={news} />
      <Goal />
      <Solution />
      <MedicalDevices />
      <Consultation />
    </Flex>
  )
}
